import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history';
import RootReducer from '../features/common/RootReducer';
import loadingMiddleware from './middleware/loadingMiddleware';
import errorHandlingMiddleware from './middleware/errorHandlingMiddleware';
import alertMiddleware from './middleware/alertMiddleware';
import { logout } from '../features/login/loginSlice';

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});

const appReducer = combineReducers({
  router: routerReducer,
  ...RootReducer,
});

//로그아웃시 모든 slice state를 초기화
const rootReducer = (state, action) => {
  // console.log('action', action);
  // console.log('logout', logout);
  if (action.type.includes('logout')) {
    state = undefined;
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .prepend(routerMiddleware)
      .concat(loadingMiddleware, errorHandlingMiddleware, alertMiddleware),
});

export default store;
export const history = createReduxHistory(store);
